import React from "react";

import Typography from "@mui/material/Typography";
import Stack from "@mui/material/Stack";
import Select from "@mui/material/Select";
import Tooltip from "@mui/material/Tooltip";
import MenuItem from "@mui/material/MenuItem";
import InputLabel from "@mui/material/InputLabel";
import FormControl from "@mui/material/FormControl";

/**
 * A common component used by property cards to display customizable enum selection fields.
 */
interface IEnumSelectorInputProps {
    label?: string;
    value?: string;
    options: { [name: string]: string };
    tooltip?: string;
    editable?: boolean;
    readOnly?: boolean;
    onValueChange: (value: string) => void;
}

const EnumSelectorInput: React.FC<IEnumSelectorInputProps> = ({ ...props }) => {
    return (
        <Stack direction="row" spacing={2} alignItems="center">
            <Tooltip title={props.tooltip || ""} arrow>
                {props.readOnly ?
                    <Typography variant="body1" component="div" sx={{ color: 'text.secondary' }}>
                        {props.label}: {props.value ? props.options[props.value] : ""}
                    </Typography>
                    :
                    <FormControl fullWidth size="small">
                        <InputLabel id="select-label" shrink>
                            {props.label}
                        </InputLabel>
                        <Select
                            labelId="select-label"
                            label={props.label}
                            value={props.value || ""}
                            disabled={!props.editable}
                            onChange={(event) => props.onValueChange(event.target.value)}
                        >
                            {Object.entries(props.options).map(([key, label]) => (
                                <MenuItem key={key} value={key}>{label}</MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                }
            </Tooltip>
        </Stack>
    );
}

export default EnumSelectorInput;
